import Appointments from './Appointments'
import SavedCars from './SavedCars'
import { register } from '~/mixins/pluggable.js'

register('board', Appointments)
register('board', SavedCars)
